import GatImg from 'gatsby-image';
import * as React from 'react';
import styled from 'styled-components';
import { media } from '../layouts/config';

export const Img = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <Image {...props} />
);

const Image = styled.img`
  height: auto;
  max-width: 100%;
`;

export const HeroImage = styled(GatImg)`
  ${media.lg`
    width: 75%;
    padding: 0;
    margin: 0;
  `};
`;
